/** Upload surface: drop zone, file picker, sample-data button. */

import { MAX_FILE_BYTES } from '../lib/csv/transactions';

export interface UploaderCallbacks {
  onText: (text: string, fileName: string) => void;
  onError: (message: string) => void;
}

export function initUploader(cb: UploaderCallbacks): void {
  const dropzone = document.querySelector<HTMLElement>('#dropzone')!;
  const fileInput = document.querySelector<HTMLInputElement>('#file-input')!;
  const sampleBtn = document.querySelector<HTMLButtonElement>('#sample-btn')!;

  function handleFile(file: File | undefined): void {
    if (!file) return;
    if (file.size > MAX_FILE_BYTES) {
      cb.onError(
        `File is ${(file.size / 1024 / 1024).toFixed(0)} MB — the limit is ${MAX_FILE_BYTES / 1024 / 1024} MB. ` +
          'Export a shorter date range.',
      );
      return;
    }
    const reader = new FileReader();
    reader.onload = () => cb.onText(String(reader.result), file.name);
    reader.onerror = () => cb.onError('Could not read the file.');
    reader.readAsText(file);
  }

  dropzone.addEventListener('click', () => fileInput.click());
  dropzone.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      fileInput.click();
    }
  });
  dropzone.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropzone.classList.add('drag');
  });
  dropzone.addEventListener('dragleave', () => dropzone.classList.remove('drag'));
  dropzone.addEventListener('drop', (e) => {
    e.preventDefault();
    dropzone.classList.remove('drag');
    handleFile(e.dataTransfer?.files[0]);
  });
  fileInput.addEventListener('change', () => {
    handleFile(fileInput.files?.[0]);
    fileInput.value = '';
  });

  sampleBtn.addEventListener('click', () => {
    sampleBtn.disabled = true;
    void (async () => {
      try {
        const res = await fetch('/sample_transactions.csv');
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        cb.onText(await res.text(), 'sample_transactions.csv');
      } catch {
        cb.onError('Could not load the sample data.');
      } finally {
        sampleBtn.disabled = false;
      }
    })();
  });
}
